import React, { FC, memo, useMemo } from 'react';

import { StyledColPadding } from './FlexRow.styles';

export interface FlexRowPaddingProps {
  paddingSize?: number;
  defaultCol?: number;
  minColWidth?: number;
}

const FlexRowPadding: FC<FlexRowPaddingProps> = ({ paddingSize, defaultCol, minColWidth }) => {
  const resolvedPaddingSize = useMemo(() => paddingSize || defaultCol, [defaultCol, paddingSize]);
  const paddingCount = useMemo(() => Array((12 / resolvedPaddingSize) - 1), [resolvedPaddingSize]);
  const paddingList = useMemo(() => (
    paddingCount.fill('').map((value, index) => index)
  ), [paddingCount]);

  return (
    <>
      {paddingList.map((index) => (
        <StyledColPadding
          col={resolvedPaddingSize}
          minColWidth={minColWidth}
          key={index}
          role="presentation"
        />
      ))}
    </>
  );
};

export default memo(FlexRowPadding);
